export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "exportation_attachment": {
            "exporter_process_exportation_file_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de adjunto"])},
            "exportation_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjunto"])},
            "exportation_attach_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre del archivo"])}
          }
        }
      },
      "en": {
        "model": {
          "exportation_attachment": {
            "exporter_process_exportation_file_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachment type"])},
            "exportation_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachment"])},
            "exportation_attach_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachment name"])}
          }
        }
      }
    }
  })
}